import React from 'react'
import {
  ProtectServerDefaultsForm,
  ProtectServerDefaultsFormProps
} from '../../../components/server-settings/protect-server-defaults-form/protect-server-defaults-form'
import { createNgReactBridgeDirective } from '../../react-bridge'

export const bridgeTestId = 'protect-server-defaults-form-loading'

export const ReactProtectServerDefaultsBridge = (
  props: ProtectServerDefaultsFormProps
) => {
  return isValid(props) ? (
    <ProtectServerDefaultsForm {...props} />
  ) : (
    <div data-testid={bridgeTestId}></div>
  )
}

function isValid({
  formData,
  licenseBreakdown,
  onChange
}: ProtectServerDefaultsFormProps) {
  if (
    onChange === undefined ||
    Object.keys(formData).some((key) => formData[key] === undefined) ||
    Object.keys(licenseBreakdown).some(
      (key) => licenseBreakdown[key] === undefined
    )
  ) {
    return false
  }

  return true
}

export const reactProtectServerDefaultsForm = createNgReactBridgeDirective(
  'reactProtectServerDefaultsForm',
  [],
  ReactProtectServerDefaultsBridge,
  ['formData', 'licenseBreakdown', 'onChange']
)
